import { M3PrdLista } from "./M3PrdLista.type";
import { M3PrdPackDet } from "./M3PrdPackDet";
import { M3CodsXPRD } from "./M3CodsXPRD.type";
import { M3PrdPackReglas } from "./M3PrdPackReglas";
export class M3PrdGeneral {
    SKU: string;
    LOTE: string;
    NOMBRE1: string;
    NOMBRELARGO: string;
    ACT1CTBL: string;
    ACT2CTBL: string;
    CTBLDPRD: string;
    CTBLDIMPPRD: string;
    SKP1: string;
    SKP2: string;
    SKP3: string;
    SKP4: string;
    SKP5: string;
    DISPONIBLE: number;
    DISPONIBLERef: number;
    M3PACK: Array<M3PrdPackDet> = null;
    M3PackReglas: Array<M3PrdPackReglas> = null;
    LoM3ListaPrecio = new Array<M3PrdLista>();
    LoM3PrdLista = new M3PrdLista();
    M3Cods = new Array<M3CodsXPRD>();
    Impuestos = new Array<M3PRDImpuestos>();
}

export class M3PRDImpuestos {
    CodImp: string;
    Metodologia: string;
    Valor: number;
}